import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from './AuthContext';

export default function Login() {
  const { login, logout, authError, loading } = useAuth();

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo">⚔</div>
        <h1 className="login-title">Card Lister</h1>
        <p className="login-subtitle">Sign in with Google to continue</p>

        {loading && <div className="login-loading">Checking session…</div>}

        {!loading && authError && (
          <div className="login-error">
            <div className="login-error-msg">
              {authError === 'Not whitelisted'
                ? 'This account is not authorized to use the app. Ask Ben to add you.'
                : authError}
            </div>
            <button className="login-back" onClick={logout}>
              Try a different account
            </button>
          </div>
        )}

        {!loading && !authError && (
          <div className="login-btn-wrap">
            <GoogleLogin
              onSuccess={(cr) => cr.credential && login(cr.credential)}
              onError={() => console.error('Google login failed')}
              theme="filled_black"
              size="large"
              shape="pill"
            />
          </div>
        )}
      </div>
    </div>
  );
}
